import { asArray, asNumber, asString, isObject } from "./model-utils";

export class EventLocation {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.coordinates = asArray(json.coordinates)
      .map(asNumber)
      .filter((coordinate) => coordinate !== undefined);
    this.type = asString(json.type);
  }

  static fromJson(json: any) {
    return isObject(json) ? new EventLocation(json) : json;
  }
}
